export enum TabViewMode {
  Tab,
  Group,
}
